import axios from 'axios';

import { WEB_POLICIES } from 'common/constants/authConstants';

axios.defaults.baseURL = `${process.env.PROXY_API_URL}`;

axios.defaults.headers['APP_ID'] = process.env.PROXY_API_APP_ID;

axios.defaults.headers['APP_SECRET'] = process.env.PROXY_API_APP_SECRET;

export const RECAPTCHA_CLIENT_KEY = process.env.RECAPTCHA_KEY;
export const GOOGLE_RECAPTCHA_URL = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_CLIENT_KEY}`;

export const handleLoadReCaptcha = setData => {
  if (setData !== undefined) {
    axios
      .get('/web_app_init')
      .then(response => {
        sessionStorage.setItem(
          WEB_POLICIES,
          response.data?.companyConfigs?.opusPolicies
        );

        setData(response.data?.companyConfigs);
      })
      .catch(error => {
        console.log(error);
      });
  }

  const loadScriptByURL = (id, url, callback) => {
    const isScriptExist = document.getElementById(id);

    if (!isScriptExist) {
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = url;
      script.id = id;
      script.onload = function() {
        if (callback) callback();
      };
      document.body.appendChild(script);
    }

    if (isScriptExist && callback) callback();
  };

  // load the script by passing the URL
  loadScriptByURL('recaptcha-key', GOOGLE_RECAPTCHA_URL, () => {
    console.log('ReCaptcha Script loaded!');
  });
};
